import React from 'react';
import Address from './Address';
import Map from './Map';
import Email from './Email';
import Slope from './Slope';
import Panels from './Panels';
import Summary from './Summary';
import Roof from './Roof';
import Advanced from './Advanced';

const StepToComponent = ({policy, step, next, state, info, change, packages, roofs, API, organization, ...rest}) => {
    if (!info || !info.front) return <Email policy={policy} state={state} change={change} {...rest} />
    switch (step) {
        case 0:
            return <Email policy={policy} state={state} next={next} change={change} {...rest} />
        case 1:
            return <Address state={state} next={next} info={info} change={change} {...rest}/>
        case 2:
            return <Map info={info} state={state} next={next} change={change} {...rest}/>
        case 3:
            return <Slope info={info} state={state} next={next} change={change} {...rest}/>
        case 4:
            return <Roof info={info} state={state} next={next} change={change} roofs={roofs} {...rest}/>
        case 5:
            return <Panels info={info} state={state} next={next} change={change} packages={packages} {...rest}/>
        case 6:
            return <Summary info={info} state={state} change={change} {...rest}/>
        case 7:
            return <Advanced info={info} state={state} organization={organization} change={change} API={API} {...rest}/>
        default:
            return <>Steg saknas</>
    } 
}

const Steps = ({policy, value, next, info, state, change, packages, organization, roofs, API}) => {
    return <StepToComponent policy={policy} next={next} step={value} info={info} state={state} change={change} packages={packages} organization={organization} roofs={roofs} API={API} />

};

export default Steps;